<svg xmlns="http://www.w3.org/2000/svg"
     width="64px" height="64px" stroke-linejoin="round"
     viewBox="0 0 64 64">
  <g fill="none" stroke="#000000" stroke-width="4">
  <path class="D10"
        d="M 32.00,4.00
           C 32.00,4.00 58.00,28.00 58.00,28.00
             58.00,28.00 58.00,36.00 58.00,36.00
             58.00,36.00 32.18,60.00 32.00,60.00
             31.82,60.00 6.00,36.00 6.00,36.00
             6.00,36.00 6.00,28.00 6.00,28.00
             6.00,28.00 32.00,4.00 32.00,4.00 Z
           M 58.00,36.00
           C 58.00,36.00 50.00,28.00 50.00,28.00
             50.00,28.00 32.00,36.00 32.00,36.00
             32.00,36.00 14.00,28.00 14.00,28.00
             14.00,28.00 6.00,36.00 6.00,36.00M 32.00,36.00
           C 32.00,36.00 32.00,60.00 32.00,60.00M 14.00,28.00
           C 14.00,28.00 32.00,4.00 32.00,4.00
             32.00,4.00 50.00,28.00 50.00,28.00
             50.00,28.00 32.00,36.00 32.00,36.00
             32.00,36.00 14.00,28.00 14.00,28.00 Z" />
   </g>
</svg>
